import { Component, ReactNode, ErrorInfo } from 'react'
import { trackException } from '@/helpers/telemetry/appInsights'
import { SeverityLevel } from '@microsoft/applicationinsights-web'

interface ErrorBoundaryProps {
    children: ReactNode
}

interface ErrorBoundaryState {
    hasError: boolean
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError(_: Error): ErrorBoundaryState {
        // Update state so the next render will show the fallback UI.
        return { hasError: true }
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        // Log the error to the console or an external service
        console.error('Caught an error:', error, errorInfo)

        // Send error to Application Insights
        trackException(error, {
            severityLevel: SeverityLevel.Error,
            properties: { source: 'ControllerLog.Frontend', componentStack: errorInfo.componentStack },
        })

        // Redirect to an error page
        if (!import.meta.env.DEV) {
            window.location.href = '/error'
        }
    }

    render() {
        if (this.state.hasError) {
            // Return null since we are redirecting, no need to render anything
            return null
        }

        return this.props.children
    }
}
